/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_TitleInputs */

const tr_landing_genius_title = /** @type {(inputs: Landing_Genius_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir chatbot değil.`)
};

const en_landing_genius_title = /** @type {(inputs: Landing_Genius_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a chatbot.`)
};

const de_landing_genius_title = /** @type {(inputs: Landing_Genius_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Chatbot.`)
};

const ru_landing_genius_title = /** @type {(inputs: Landing_Genius_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это не чат-бот.`)
};

/**
* | output |
* | --- |
* | "Not a chatbot." |
*
* @param {Landing_Genius_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_title = /** @type {((inputs?: Landing_Genius_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_title(inputs)
	if (locale === "de") return de_landing_genius_title(inputs)
	if (locale === "ru") return ru_landing_genius_title(inputs)
	return tr_landing_genius_title(inputs)
});